import { PetsEnum, RecurrenceEnum } from "../SalesLead/Lead.model";
import { SowFrequencyEnum } from "./ContractForm/ContractForm.hooks";
import { JobFrequencyEnum } from "./CreateJobAndSchedule/CreateJobAndSchedule.model";

export enum ContractStatusEnum {
  Draft = "DRAFT",
  Pending = "PENDING",
  Approved = "APPROVED",
  Denied = "DENIED",
  Sent = "SENT",
  Completed = "COMPLETED",
}

export enum EmployeeContractStatusEnum {
  Pending = "PENDING",
  Denied = "DENIED",
}

export type TSowFrequencies = {
  sowId: number;
  frequency: SowFrequencyEnum;
};

export type TContractForm = {
  contractTypeId: number | null;
  leadId: number;
  compensation: string;
  cancellation: number;
  sendStatus: boolean;
  amount: number;
  sowFrequencies: TSowFrequencies[];
  estimatedSQFT?: number;
  typeOfSpace: string;
  typeOfFloorSurfaceIds: string[];
  suppliesIds: string[];
  paperProductIds: number[];
  recurrence: RecurrenceEnum;
  frequency: JobFrequencyEnum;
  pets: PetsEnum;
  scopeOfWorkIds: number[];
  daysOfWeek: number[];
  recurEvery?: number;
  dayOfMonth?: number;
  monthOfYear?: number;
  recurrenceEndDate?: Date | string | null;
  endDate?: Date | string | null;
};

export interface IContract {
  clientId: string;
  compensation: string;
  contractTypeId: number;
  createdAt: string;
  createdBy: string;
  frId: number;
  id: string;
  isDeleted: boolean;
  leadId: number;
  pdfPath: string;
  sendStatus: boolean;
  status: ContractStatusEnum;
  paperProducts: any[];
  // scopeOfWorks: any[]
  supplies: any[];
  updatedAt: string;
  updatedBy: string;
}
